define('floorDate/floorDate',['require','ensureDate/ensureDate'],function(require){
  
  var ensureDate = require('ensureDate/ensureDate');

  return function (floor, date, clone, firstDay) {

    // Sending toString will ensure new date
    date = ensureDate(clone ? date.toString() : date);

    switch (floor || 'day') {
      case 'year':   date.setMonth(0);
      case 'month':
      case 'week':   date.setDate(floor === 'week' ? date.getDate() - date.getDay() + ~~+firstDay : 1);
      case 'day':    date.setHours(0);
      case 'hour':   date.setMinutes(0);
      case 'minute': date.setSeconds(0);
      default:       date.setMilliseconds(0);
    }

    return date;
  };
});
